import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { ProductDialog } from 'src/modules/supply_chain/components/ProductDialog'
import { skuit } from 'src/services/skuit'

import { ProductListTable } from 'src/components/Table/list/Product'
import { ListPage } from 'src/components/Pages/ListPage'

export const ProductListPage = () => {
  const paginator = useQueryPaginator('product-list', skuit.sc.products.list)

  const exportFields = [
    "primary_barcode_type",
    "guid",
    "height",
    "length",
    "primary_barcode",
    "name",
    "weight",
    "width",
  ]

  return (
    <ListPage
      title='Products'
      paginator={paginator}
      dialogs={[{ title: 'New Product', Dialog: ProductDialog }]}
    >
      <ProductListTable
        paginator={paginator}
        fields={['name', 'primaryBarcode', 'primaryImage']}
        bulkActions={['printProduct']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.products.export
        }}
      />
    </ListPage>
  )
}
